import React, { useCallback, useMemo, useState } from "react";
import { BaseDisplay, Display } from "stentor-models";
import { ActionButton } from "../components/ActionButton";
import { ChatMessagePart } from "../components/ChatMessagePart";
import { MultiSelect, MultiSelectCheckedMap } from "../components/MultiSelect";
import { ChatMessageRequestCustom } from "../xapp/ChatServerMessage";
import { MessageMiddlewareBuilder, MessageMiddlewareFC } from "./message-middleware";

export interface MultiSelectDisplayItem {
    readonly id: string;
    readonly title: string;
}

export type MultiSelectDisplay = Display & {
    readonly type: "MultiSelect",
    readonly items: readonly MultiSelectDisplayItem[];
}

function isMultiSelect(display: Display): display is MultiSelectDisplay {
    return (display as BaseDisplay).type === "MultiSelect";
}

function convertToMultiSelectItems(display: MultiSelectDisplay): readonly MultiSelectDisplayItem[] {
    return display.items;

}

export const MultiSelectMiddlewareWidget: MessageMiddlewareFC<MultiSelectDisplay> = props => {
    const { msg, ctx } = props;

    const items = useMemo<readonly MultiSelectDisplayItem[]>(() => convertToMultiSelectItems(msg), [msg]);

    const user = ctx.user;

    const [checked, setChecked] = useState<MultiSelectCheckedMap>({});

    const handleSubmit = useCallback(() => {
        ctx.send({
            type: "custom",
            payload: JSON.stringify({
                type: "OPTION_SELECT_REQUEST",
                intentId: "OptionSelect",
                selected: Object.keys(checked).map(k => ({ id: k }))
            })
        } as ChatMessageRequestCustom)
    }, [ctx, checked]);

    return (
        <ChatMessagePart showAvatar={true} user={user}>
            <div className="chat-msg">
                <div>
                    <MultiSelect items={items} checked={checked} onChange={setChecked} />
                    <ActionButton label="Submit" onClick={handleSubmit} />
                </div>
            </div>
        </ChatMessagePart>
    );
};

export const MultiSelectMiddleware: MessageMiddlewareBuilder = next => props => {
    const { msg, ctx } = props;

    if (isMultiSelect(msg)) {
        return <MultiSelectMiddlewareWidget msg={msg} ctx={ctx} />;
    }
    return next(props);
};